/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {withDLSTheme} from '../../theme/withDLSTheme';
import {SwitchWrapper as CurrentSwitch} from './current/Switch';
import {LabelPlacement, SwitchWrapper as LegacySwitch} from './legacy/Switch';

// This is essential if a client imports the `Switch` component using
// `import {Switch} from ‘./Switch’;`
export const Switch = withDLSTheme(LegacySwitch, CurrentSwitch);
// eslint-disable-next-line no-barrel-files/no-barrel-files
export {LabelPlacement};

export default Switch;
